<template>
  <PickLotteryQuickPickCard
    v-model:collapsed="isRandom"
    body-class="pt-300"
    :headline="$t('picklottery.quickpick.numbers.headline')"
  >
    <NumberPicker
      v-bind="{ ...numberPickerProps, fields }"
      :value="value ?? undefined"
      @change="onChange"
    />
    <LcInfoText v-if="lockoutLottery" class="mt-100 text-secondary-secondary" size="small">
      {{ $t('picklottery.disclaimer.lockoutlottery') }}
    </LcInfoText>
  </PickLotteryQuickPickCard>
</template>

<script lang="ts" setup>
import type { QuickPickSettings } from '../stores/lottery'
import type { NumberPickerChangeEventValue, NumberPickerProps } from './NumberPicker.vue'

type PickLotteryQuickPickNumbersEmits = {
  (event: 'update:value', value: PickLotteryQuickPickNumbersProps['value']): void
}

type PickLotteryQuickPickNumbersProps = Omit<NumberPickerProps, 'value'> & {
  lockoutLottery?: boolean
  value?: QuickPickSettings['numbers']
}

const emit = defineEmits<PickLotteryQuickPickNumbersEmits>()
const {
  fields = [],
  value = null,
  ...numberPickerProps
} = defineProps<PickLotteryQuickPickNumbersProps>()

const isRandom = computed({
  get: () => !value,
  set: (newValue) => {
    emit('update:value', newValue ? null : [])
  },
})

const onChange = (newValue: NumberPickerChangeEventValue) => {
  const index = fields.findIndex((field) => field?.name === newValue.name)
  if (index < 0) return

  const selectedNumbers = value ? [...value] : []
  while (selectedNumbers.length <= index) {
    selectedNumbers.push(null)
  }
  selectedNumbers[index] = newValue.value
  emit('update:value', selectedNumbers?.length ? selectedNumbers : null)
}
</script>
